import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-accommodation-type.reducer'; // Assurez-vous que le chemin est correct
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParAccommodationTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, [dispatch, props.match.params.id]);

  const parAccommodationTypeEntity = useAppSelector(state => state.parAccommodationType.entity);

  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parAccommodationTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.detail.title">ParAccommodationType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parAccommodationTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.code">Code</Translate>
            </span>
          </dt>
          <dd>{parAccommodationTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.name">Name</Translate>
            </span>
          </dt>
          <dd>{parAccommodationTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{parAccommodationTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{parAccommodationTypeEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.status">Status</Translate>
            </span>
          </dt>
          <dd>
            <Translate contentKey={`almobadaraMasterDataApp.Status.${parAccommodationTypeEntity.status}`} />
          </dd>
        </dl>
        <Button tag={Link} to="/par-accommodation-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-accommodation-type/${parAccommodationTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParAccommodationTypeDetail;
